module.exports = __webpack_public_path__ + "img/V-63-ER-1500-B.2e9adf11.png";